import { render, staticRenderFns } from "./custom-metadata-panel.vue?vue&type=template&id=38e5949c&scoped=true&"
import script from "./custom-metadata-panel.ts?vue&type=script&lang=ts&"
export * from "./custom-metadata-panel.ts?vue&type=script&lang=ts&"
import style0 from "./custom-metadata-panel.scss?vue&type=style&index=0&id=38e5949c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e5949c",
  null
  
)

export default component.exports